import React from 'react';
import { reduxForm } from 'redux-form';

import validate from '../validate';

import { MdCheckCircle as CheckIcon } from 'react-icons/md';
import FlatButton from 'material-ui/FlatButton';
import { formatMoney } from 'helpers/Formatter';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  creditCardbutton: {
    color: 'white',
    height: '40px',
  },
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  details: {
    fontFamily: 'Circular',
  },
  emphasis: {
    fontFamily: 'Circular-Black',
  },
};

let WizardFormLeasePaymentsPage = (props) => {
  const {
    handleSubmit,
    previousPage,
    openCreditCard,
    dontForcePayment,
    totalPaymentAmount,
    totalPaymentAmountCredit,
    paymentProvider,
    hasPaid,
  } = props;

  const amountToPay = paymentProvider === 'paysafe' ? totalPaymentAmount : totalPaymentAmountCredit;

  return (
    <div style={{ marginTop: '50px' }}>
      <div>
        <h3
          style={{
            fontSize: '30px',
            marginBottom: '20px',
            fontFamily: 'Circular-Bold',
          }}
        >
          {getTranslatedString('tenantPortal.application.payment.method')}
        </h3>
        <h4 style={style.details}>
          {getTranslatedString('tenantPortal.application.payment.worry')}{' '}
          <b style={style.emphasis}>
            {getTranslatedString('tenantPortal.application.payment.charges')}
          </b>
        </h4>
      </div>
      <div style={{ marginTop: '30px' }}>
        {hasPaid && (
          <div className="row" style={{ textAlign: 'center' }}>
            <CheckIcon style={{ fontSize: '125px', color: '#4cca6e' }} />
            <p style={{ margin: '10px 0' }}>
              {getTranslatedString('tenantPortal.application.payment.received')}
            </p>
            <FlatButton
              label={getTranslatedString('tenantPortal.application.payment.button.continue')}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.creditCardbutton}
              onClick={handleSubmit}
            />
          </div>
        )}
        {!hasPaid && (
          <div>
            <div className="row" style={{ textAlign: 'center' }}>
              <FlatButton
                label={getTranslatedString('tenantPortal.application.payment.button.pay', {
                  amountToPay: formatMoney(amountToPay),
                })}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.creditCardbutton}
                onClick={openCreditCard}
              />
            </div>
            {dontForcePayment && (
              <div className="row" style={{ textAlign: 'center' }}>
                <h5 style={{ fontSize: '12px' }}>
                  <button type="button" className="link-button" onClick={handleSubmit}>
                    {getTranslatedString('tenantPortal.application.payment.button.differentMethod')}
                  </button>
                </h5>
              </div>
            )}
          </div>
        )}
        <div className="row" style={{ marginTop: '70px' }} />
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label={getTranslatedString('tenantPortal.application.payment.button.back')}
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

WizardFormLeasePaymentsPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardFormLeasePaymentsPage);

export default WizardFormLeasePaymentsPage;
